module.exports = __webpack_public_path__ + "media/images/lb/904-bac859c1c3eaf5d2e6af7056910e5183.svg";